import { Breadcrumb, Container } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getRoute } from "@/functions/getRoute";

export default function BreadcrumbNavigation({ className, items }) {
  return (
    <div className={clsx(className, classes.breadcrumbs)}>
      <Container className="mw-xxl">
        <Breadcrumb>
          <Breadcrumb.Item href={getRoute("home")}>Home</Breadcrumb.Item>
          {items.map(({ label, href }, k) => {
            const isLast = k === items.length - 1;
            return (
              <Breadcrumb.Item key={k} href={!isLast ? href : undefined} active={isLast}>
                {label.toLowerCase() == "csr" ? label.toUpperCase() : label}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      </Container>
    </div>
  );
}

BreadcrumbNavigation.defaultProps = {
  className: "",
  items: [],
};

BreadcrumbNavigation.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
};
